export default __webpack_public_path__ + "i18n/translations/translation-ja.b5166c41.json";